// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PFileCopyOutlinedSvg from "@fishx/icons-svg/es/asn/PFileCopyOutlined";
import FishxIcon from '../components/FishxIcon';

var PFileCopyOutlined = function PFileCopyOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PFileCopyOutlinedSvg
  }));
};

PFileCopyOutlined.displayName = 'PFileCopyOutlined';
export default React.forwardRef(PFileCopyOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PFileCopyOutlined.js
// module id = 3377
// module chunks = 0